import { useState, useEffect } from "react";

export default function useFetch(url, token, payload) {
  const [data, setData] = useState(null);

  const fetchOptions = {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, *same-origin, omit
    headers: {
      "X-Access-Token": token,
      "Content-Type": "application/json",
    },
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: JSON.stringify({ context: payload }), // body data type must match "Content-Type" header
  };

  const call = async (x) => {
    const response = await fetch(url, {
      ...fetchOptions,
      //body: JSON.stringify({ context: x }),
    });
    console.log("call api with:", x);
    const returnData = await response.json();
    //console.log(returnData);
    setData(returnData.result);
  };
  return [call, data];
}
